export default __webpack_public_path__ + "static/media/ic_scroll_right.af0dad58.svg";